import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 12 2",
  "content": "<symbol viewBox=\"0 0 12 2\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-minus\"><path d=\"M0 2.13V0h12.36v2.13H0z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol